<template>
  <div class="questionnaire-info app-region blank-t-v blank-b-v blank-l-h blank-r-h" v-if="!isScan">
    <a-steps :current="currentStep">
      <a-step>
        <template slot="title">活动信息</template>
      </a-step>
      <a-step>
        <template slot="title">题目设计</template>
      </a-step>
    </a-steps>
    <a-form-model class="app-form" ref="form" :rules="rules" :model="form" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" v-show="currentStep === 0">
      <a-form-model-item label="活动名称" prop="title">
        <a-input v-model="form.title" placeholder="请输入活动名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="活动起止时间" prop="time">
        <a-range-picker v-model="form.time" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
      </a-form-model-item>
      <a-form-model-item label="活动封面" prop="avatar">
        <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange" preview>
          <dy-image :src="form.avatar" v-if="form.avatar"></dy-image>
          <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="发布社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择发布社区" :disabled="!!id || !isPlatformRole">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="消息推送状态" prop="push">
        <a-radio-group v-model="form.push">
          <a-radio :value="1">推送</a-radio>
          <a-radio :value="0">不推送</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="积分数额" prop="score">
        <a-input-number v-model="form.score" placeholder="请输入奖励积分数额" :min="0"></a-input-number>
      </a-form-model-item>
      <!-- <a-form-model-item label="活动介绍" prop="note">
        <editor name="editor" v-model="form.note"></editor>
      </a-form-model-item> -->
      <a-form-model-item label="活动简介" prop="content">
        <a-textarea v-model="form.content" placeholder="请输入活动简介"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="currentStep = 1">下一步</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <template v-if="currentStep === 1">
      <a-row type="flex" :gutter="[32, 32]">
        <a-col>
          <a-space direction="vertical" class="bar">
            <a-button block @click="addQuestion('radio')">单选按钮</a-button>
            <a-button block @click="addQuestion('checkbox')">多选按钮</a-button>
            <a-button block @click="addQuestion('input')">单行文本框</a-button>
            <a-button block @click="addQuestion('textarea')">多行文本框</a-button>
          </a-space>
        </a-col>
        <a-col flex="1">
          <p class="question-title">题目设置</p>
          <a-row :gutter="[0, 32]" v-if="question">
            <a-col>
              <a-row type="flex">
                <a-col>类型：</a-col>
                <a-col>{{question.type === 'radio' ? '单选按钮' : (question.type === 'checkbox' ? '多选按钮' : (question.type === 'input' ? '单行文本框' : '多行文本框'))}}</a-col>
              </a-row>
            </a-col>
            <a-col>
              <a-row type="flex">
                <a-col>是否必填：</a-col>
                <a-col>
                  <a-checkbox :checked="question.required" @change="changeRequired">必填</a-checkbox>
                </a-col>
              </a-row>
            </a-col>
            <a-col>
              <a-row type="flex">
                <a-col class="app-text">题目：</a-col>
                <a-col flex="1">
                  <a-input v-model="question.title" placeholder="请输入题目名称" allow-clear></a-input>
                </a-col>
              </a-row>
            </a-col>
            <a-col>
              <a-row type="flex">
                <a-col class="app-text">备注：</a-col>
                <a-col flex="1">
                  <a-input v-model="question.desc" placeholder="请输入题目备注" allow-clear></a-input>
                </a-col>
              </a-row>
            </a-col>
            <a-col v-if="question.options">
              <a-row type="flex">
                <a-col class="app-text">选项：</a-col>
                <a-col flex="1">
                  <a-row type="flex" :gutter="[8, 8]" align="middle">
                    <a-col class="question-option" v-for="(m, n) in question.options" :key="n">
                      <a-input v-model="question.options[n]" allow-clear></a-input>
                      <a-icon type="close-circle" @click="delQuestionOption(n)"></a-icon>
                    </a-col>
                    <a-col>
                      <a-icon type="plus" @click="addQuestionOption"></a-icon>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </a-col>
            <a-col v-if="question.type === 'textarea'">
              <a-row type="flex">
                <a-col class="app-text">行数：</a-col>
                <a-col flex="1">
                  <a-input-number v-model="question.extends.row" allow-clear :min="1"></a-input-number>
                </a-col>
              </a-row>
            </a-col>
            <a-col>
              <a-space class="bottom-btns">
                <a-button type="primary" @click="appendQuestion">确定</a-button>
                <a-button @click="cancelQuestion">取消</a-button>
              </a-space>
            </a-col>
          </a-row>
          <a-empty v-else></a-empty>
        </a-col>
        <a-col flex="1">
          <p class="question-title">预览问卷</p>
          <a-row :gutter="[0, 32]" v-if="form.questions.length">
            <a-col v-for="(value, index) in form.questions" :key="index">
              <a-space direction="vertical">
                <p>{{value.required ? '*' : null}}{{index + 1}}、{{value.title}}</p>
                <p v-if="value.desc">{{value.desc}}</p>
                <a-radio-group v-if="value.type === 'radio'">
                  <a-radio :value="m" v-for="(m, n) in value.options" :key="n">{{m}}</a-radio>
                </a-radio-group>
                <a-checkbox-group :options="value.options" v-if="value.type === 'checkbox'"></a-checkbox-group>
                <a-input v-if="value.type === 'input'"></a-input>
                <a-textarea v-if="value.type === 'textarea'"></a-textarea>
              </a-space>
              <a-row :gutter="[16, 0]" type="flex">
                <a-col>
                  <a-button type="link" @click="editQuestion(index)">编辑</a-button>
                </a-col>
                <a-col>
                  <a-button type="link" @click="copyQuestion(value)">复制</a-button>
                </a-col>
                <a-col>
                  <a-button type="link" @click="delQuestion(index)">删除</a-button>
                </a-col>
                <a-col v-if="index">
                  <a-button type="link" @click="moveUpQuestion(value, index)">上移</a-button>
                </a-col>
                <a-col v-if="index !== form.questions.length - 1">
                  <a-button type="link" @click="moveDownQuestion(value, index)">下移</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-empty v-else></a-empty>
        </a-col>
      </a-row>
      <a-space class="bottom-btns">
        <a-button type="primary" @click="currentStep = 0">上一步</a-button>
        <a-button type="primary" @click="submit">确定</a-button>
        <a-button @click="cancel">取消</a-button>
      </a-space>
    </template>
  </div>
  <div class="questionnaire-info" v-else>
    <a-descriptions title="活动信息" bordered v-viewer>
      <a-descriptions-item label="活动名称">{{form.title}}</a-descriptions-item>
      <a-descriptions-item label="活动起止时间">{{form.time.join('-')}}</a-descriptions-item>
      <a-descriptions-item label="活动封面">
        <dy-image :src="form.avatar"></dy-image>
      </a-descriptions-item>
      <a-descriptions-item label="发布社区">{{communityOptions.filter(val => form.community.indexOf(val.id) > -1).map(val => val.name).join('、')}}</a-descriptions-item>
      <a-descriptions-item label="消息推送状态">{{form.push ? '推送' : '不推送'}}</a-descriptions-item>
      <a-descriptions-item label="积分数额">{{form.score}}</a-descriptions-item>
      <!-- <a-descriptions-item label="活动介绍" :span="3"><span v-html="form.note"></span></a-descriptions-item> -->
      <a-descriptions-item label="活动简介" :span="3">{{form.content}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="题目设计">
      <a-descriptions-item>
        <a-row :gutter="[0, 32]">
          <a-col v-for="(value, index) in form.questions" :key="index">
            <a-space direction="vertical">
              <p>{{value.required ? '*' : null}}{{index + 1}}、{{value.title}}</p>
              <p v-if="value.desc">{{value.desc}}</p>
              <a-radio-group v-if="value.type === 'radio'">
                <a-radio :value="m" v-for="(m, n) in value.options" :key="n">{{m}}</a-radio>
              </a-radio-group>
              <a-checkbox-group :options="value.options" v-if="value.type === 'checkbox'"></a-checkbox-group>
              <a-input v-if="value.type === 'input'"></a-input>
              <a-textarea v-if="value.type === 'textarea'"></a-textarea>
            </a-space>
          </a-col>
        </a-row>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
  import CommunityService from '@/io/community.js';
  import QuestionnaireService from '@/io/questionnaire.js';

  export default {
    name: 'QuestionnaireInfo',
    props: {
      isScan: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default() {
          return this.$route.params.id * 1;
        }
      }
    },
    data() {
      return {
        currentStep: 0,
        avatar: {
          loading: false,
        },
        communityOptions: [],
        questionIndex: null,
        question: null,
        form: {
          title: null,
          time: [],
          avatar: null,
          community: [],
          push: null,
          score: null,
          note: null,
          content: null,
          questions: []
        },
        rules: {
          title: [
            {
              required: true,
              message: "请输入活动名称",
            },
          ],
          time: [
            {
              required: true,
              message: "请选择活动起止时间",
            },
          ],
          avatar: [
            {
              required: true,
              message: "请上传活动封面",
            },
          ],
          community: [
            {
              required: true,
              message: "请选择发布社区",
            },
          ],
          push: [
            {
              required: true,
              message: "请选择消息推送状态",
            },
          ],
          score: [
            {
              required: true,
              message: "请输入积分数额",
            },
          ],
          // note: [
          //   {
          //     required: true,
          //     message: "请输入活动介绍",
          //   },
          // ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initCommunity().then(() => {
            this.initPage();
          });
        },
        immediate: true,
      },
    },
    methods: {
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
        if (this.id) {
          QuestionnaireService.info(this.id).then(res => {
            this.form.title = res.title;
            this.form.time = [res.start_time, res.ended_at];
            this.form.avatar = res.banner;
            this.form.community = res.community_ids;
            this.form.push = res.status;
            this.form.score = res.score;
            this.form.note = res.description;
            this.form.content = res.desc;
            this.form.questions = res.questions;
          }).catch(err => {});
        }
      },
      addQuestion(type, title) {
        let options = null;
        if (type === 'radio' || type === 'checkbox') {
          options = ['选项1', '选项2'];
        }
        this.question = {
          id: null,
          type,
          title,
          desc: null,
          required: true,
          options,
          extends: type === 'textarea' ? {row: 1} : null
        };
      },
      changeRequired() {
        this.question.required = !this.question.required;
      },
      addQuestionOption() {
        this.question.options.push('选项');
      },
      delQuestionOption(index) {
        this.question.options.splice(index, 1);
      },
      appendQuestion() {
        if (this.checkQuestion()) {
          if (typeof this.questionIndex === 'number') {
            this.form.questions[this.questionIndex] = this.question;
          } else {
            this.form.questions.push(this.question);
          }
          this.cancelQuestion();
        }
      },
      checkQuestion() {
        let status = true;
        if (!this.question.title) {
          this.$message.error('请填写题目');
          status = false;
        }
        if (this.question.options && this.question.options.filter(val => !val).length) {
          this.$message.error('请填写选项');
          status = false;
        }
        return status;
      },
      cancelQuestion() {
        this.questionIndex = null;
        this.question = null;
      },
      editQuestion(index) {
        this.questionIndex = index;
        this.question = this.$createNewVariable(this.form.questions[index]);
      },
      copyQuestion(data) {
        this.form.questions.push(data);
      },
      delQuestion(index) {
        this.form.questions.splice(index, 1);
      },
      moveUpQuestion(data, index) {
        let newData = this.form.questions.splice(index - 1, 1, data)[0];
        this.form.questions[index] = newData;
      },
      moveDownQuestion(data, index) {
        let newData = this.form.questions.splice(index + 1, 1, data)[0];
        this.form.questions[index] = newData;
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          if (status === 'done') {
            this.avatar.loading = false;
            this.form.avatar = info.file.response.media;
          } else {
            this.avatar.loading = true;
          }
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            QuestionnaireService.edit(
              this.id,
              this.form.title,
              this.form.time[0],
              this.form.time[1],
              this.form.avatar,
              this.form.community,
              this.form.push,
              this.form.score,
              this.form.note,
              this.form.content,
              this.form.questions
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            QuestionnaireService.add(
              this.form.title,
              this.form.time[0],
              this.form.time[1],
              this.form.avatar,
              this.form.community,
              this.form.push,
              this.form.score,
              this.form.note,
              this.form.content,
              this.form.questions
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        }, () => {
          this.currentStep = 0;
        });
      },
      cancel() {
        this.$router.push({
          name: 'CommunityActivity'
        });
      },
    }
  }
  </script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .ant-steps {
    width: 30%;
    margin: 0 auto @padding-lg auto;
  }
  .bar {
    text-align: center;
  }
  .question-option {
    position: relative;
    .anticon {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .bottom-btns {
    width: 100%;
    justify-content: center;
  }
  .question-title {
    text-align: center;
    background-color: @background-color-base;
    font-weight: bold;
    padding: @padding-xs;
    margin-bottom: @padding-lg;
  }
</style>